import { HERO_SECTION_ID } from 'helpers';
import { useMediaQuery } from 'hooks';
import { LayoutContainer } from 'layout';
import { Button, SectionContainer } from 'ui';
import { SvgElement } from './svg-hero-element';

import {
    heroContent,
    screenMobileL,
    screenTablet,
    screenLaptop,
    sectionContainer,
    layoutContainer,
    section,
    inputContainer,
    middle,
    writter,
    heroText,
    description
} from './hero-section.module.scss';
import { useEffect, useState } from 'react';
import { Typewriter } from 'react-simple-typewriter';

export const HeroSection = () => {
    const isMobile = useMediaQuery(`(max-width: ${screenMobileL})`);
    const isTablet = useMediaQuery(`(min-width: ${screenTablet})`);
    const isLaptop = useMediaQuery(`(min-width:${screenLaptop})`);
    const [email, setEmail] = useState('');
    const [moveToTop, setMovetToTop] = useState(true);
    const DELAY_SPEED = 1500;
    const TYPE_SPEED = 60;

    useEffect(() => {
        const interval = setInterval(() => {
            setMovetToTop(prev => !prev);
        }, 5000);

        return () => clearInterval(interval);
    }, [moveToTop]);

    return (
        <section id={HERO_SECTION_ID} className={section}>
            <LayoutContainer className={layoutContainer}>
                <SectionContainer className={sectionContainer}>
                    <div className={heroContent}>
                        <div className={heroText}>
                            <h1>Organize your knowledge and boost your academic</h1>
                            <div className={writter}>
                                <Typewriter
                                    words={['productivity', '   creativity   ']}
                                    loop={0}
                                    cursor={false}
                                    cursorBlinking
                                    typeSpeed={TYPE_SPEED}
                                    deleteSpeed={0}
                                    delaySpeed={DELAY_SPEED}
                                />
                            </div>
                        </div>
                        <div className={middle}>
                            {isTablet ? <SvgElement isLaptop={isLaptop} /> : <></>}
                            <span className={description}>
                                Elumity will change the way you organize and grow your knowledge and career in the age
                                of digital information overload.
                            </span>
                        </div>
                        <div className={inputContainer}>
                            <input
                                onChange={event => {
                                    setEmail(event.target.value);
                                }}
                                value={email}
                                placeholder="Enter your email"
                                type="email"
                            />
                            <a href={process.env.GATSBY_ELUMITY_APP_URL + '/signup/' + email}>
                                <Button text="Create free account" fullWidth={isMobile} />
                            </a>
                        </div>
                    </div>
                </SectionContainer>
            </LayoutContainer>
        </section>
    );
};
